import React, { useState, useEffect } from "react";

import { Link } from "react-router-dom";
import LinkMui from "@mui/material/Link";
import i18n from "../i18n.js";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import LockPersonIcon from "@mui/icons-material/LockPerson";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import KeyIcon from "@mui/icons-material/Key";
import Input from "@mui/material/Input";
import { useForm, Controller } from "react-hook-form";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";

const Home = (props) => {
    const { itemOptions } = props;
    const { comp, pzstReg, api, user } = itemOptions;
    const { t } = i18n;

    const [message, setMessage] = useState("");
    const [code, setCode] = useState("");

    const [openError, setOpenError] = useState(false);
    const [openSuccess, setOpenSuccess] = useState(false);
    const handleOpenError = () => {
        setOpenError(true);
    };

    const handleCloseError = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setOpenError(false);
    };
    const handleOpenSuccess = () => {
        setOpenSuccess(true);
    };

    const handleCloseSuccess = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setOpenSuccess(false);
    };
    const {
        handleSubmit,
        control,
        watch,
        formState: { errors, isValid },
    } = useForm({
        defaultValues: {
            code: "",
        },
    });
    const onSubmit = (data) => {
        if (isValid || Object.entries(errors).length === 0) {
            axios
                .put(`${api.checkCode}${comp.id}`, { code: data.code })
                .then((res) => {
                    // console.log(res);
                    setMessage(res.data);
                    if (res.status === 200) {
                        handleOpenSuccess();
                        setCode(data.code);
                        window.code = data.code;
                    } else {
                        handleOpenError();
                    }
                })
                .catch(function (error) {
                    setMessage(error.response.data);

                    handleOpenError();
                    console.log(error);
                });
            // console.log('ok', data);
        } else {
            console.log(errors);
        }
    };
    const onError = (errors, e) => {
        console.log(errors);
    };
    return (
        <React.Fragment>
            <Container maxWidth="md" className="mb-2" sx={{ display: "flex", justifyContent: "center" }}>
                {comp.status.registrationOpen === false && code === "" && (
                    <Stack spacing={2}>
                        <Alert severity="error" variant="outlined">
                            <AlertTitle>{t("reg.status.comp.closed")}</AlertTitle>
                            {t("reg.info.additional_info_rules")}
                        </Alert>
                        <Stack direction={"row"} spacing={2}>
                            <FormControl variant="standard" fullWidth>
                                <InputLabel htmlFor="code-enter">{t("code.enter")}</InputLabel>
                                <Controller
                                    name="code"
                                    control={control}
                                    render={({ field }) => (
                                        <Input
                                            {...field}
                                            required
                                            error={errors.code !== undefined}
                                            startAdornment={
                                                <InputAdornment position="start">
                                                    <KeyIcon />
                                                </InputAdornment>
                                            }
                                        />
                                        // <TextField
                                        //     {...field}
                                        //     label={`${t("first_name")}`}
                                        //     type="text"
                                        //     required
                                        //     error={errors.firstName !== undefined}
                                        //     helperText={errors.firstName !== undefined ? t("reg.wdsf.helper.not_empty") : ""}
                                        // />
                                    )}
                                />
                            </FormControl>
                            <Button variant="contained" color="warning" disabled={watch("code") === ""} onClick={handleSubmit(onSubmit, onError)}>
                                {t("code.use")}
                            </Button>
                        </Stack>
                    </Stack>
                )}
                {(comp.status.registrationOpen === true || code !== "") && (
                    <Box>
                        <Stack spacing={2} direction={{ xs: "column", md: "row" }}>
                            {comp.categoriesAll.length > 0 && (
                                <LinkMui href={code !== "" ? `${pzstReg}#/starters/${code}` : `${pzstReg}#/starters`} sx={{ textDecoration: "none" }}>
                                    <Button variant="contained" size="large" color="primary" startIcon={<LockPersonIcon />}>
                                        {t("reg.from_pzst")}
                                    </Button>
                                </LinkMui>
                            )}
                            {comp.categoriesAll.length > 0 && !comp.onlyNational && (
                                <Link to="/wdsf" state={{ code: code }}>
                                    <Button variant="contained" size="large" color="error">
                                        {t("reg.from_wdsf")}
                                    </Button>
                                </Link>
                            )}
                            {comp.categoriesAll.length > 0 && !comp.onlyNational && (
                                <Link to="/open" state={{ code: code }}>
                                    <Button variant="contained" size="large" color="warning">
                                        {t("reg.from_form")}
                                    </Button>
                                </Link>
                            )}
                            {comp.categoriesAll.length > 0 && comp.isHobby && (
                                <LinkMui href={code !== "" ? `${pzstReg}#/hobby/${code}` : `${pzstReg}#/hobby`} sx={{ textDecoration: "none" }}>
                                    <Button variant="contained" size="large" color="warning" startIcon={<LockPersonIcon />}>
                                        {t("reg.hobby_from_pzst")}
                                    </Button>
                                </LinkMui>
                            )}
                            {comp.eventsAll.length > 0 && (
                                <LinkMui href={code !== "" ?`${pzstReg}#/person/${code}` :`${pzstReg}#/person`} sx={{ textDecoration: "none" }}>
                                    <Button variant="contained" size="large" color="success" startIcon={<LockPersonIcon />}>
                                        {t("reg.from_pzst_events")}
                                    </Button>
                                </LinkMui>
                            )}
                        </Stack>
                    </Box>
                )}
                <Snackbar open={openError} autoHideDuration={6000} onClose={handleCloseError}>
                    <Alert onClose={handleCloseError} severity="error" sx={{ width: "100%" }}>
                        {message}
                    </Alert>
                </Snackbar>
                <Snackbar open={openSuccess} autoHideDuration={6000} onClose={handleCloseSuccess}>
                    <Alert onClose={handleCloseSuccess} severity="success" sx={{ width: "100%" }}>
                        {message}
                    </Alert>
                </Snackbar>
            </Container>
        </React.Fragment>
    );
};

export default Home;
